export enum ContractStatus {
  'Open' = 0,
  'Archived' = 1,
}
